import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export const MobileCartFAB = ({ count, total, currencySymbol, onOpen }) => {
  const { t } = useLanguage();
  return (
    <div className="fixed bottom-4 left-4 right-4 lg:hidden z-40" data-testid="pos-mobile-cart-bar">
      <Button
        className="w-full h-12 bg-primary hover:bg-primary/90 rounded-2xl shadow-lg shadow-primary/20"
        onClick={onOpen}
      >
        <ShoppingCart size={18} className="mr-2" />
        <span className="font-bold text-sm">{count} {t('pos_items')}</span>
        <span className="mx-2 opacity-50">|</span>
        <span className="font-bold text-sm">{currencySymbol} {total.toFixed(2)}</span>
      </Button>
    </div>
  );
};

export default MobileCartFAB;
